import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

export const useAccessoriGroups = () => {
  const [groups, setGroups] = useState(['Portachiavi']);
  useEffect(() => {
    axios.get(`${API}/collections/Accessori/categories`).then((r) => setGroups(r.data)).catch(() => {});
  }, []);
  return groups;
};
